var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodeRemoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 20 20",
    id: "svg6098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6102"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 12.616627,3.2939174 C 11.826248,3.3145832 11.040401,3.4220458 10.276329,3.6266388 6.3306765,4.6838554 3.4584416,8.0712583 3.0830202,12.11005 3.458446,8.0712583 6.3306765,4.6838554 10.276329,3.6266388 11.040399,3.4220462 11.826254,3.3099335 12.616627,3.2939174 Z",
    style: {
      clipRule: "evenodd",
      fill: "none",
      fillRule: "evenodd",
      stroke: "#3F3F3F",
      strokeWidth: 0.61421096,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      shapeRendering: "geometricPrecision"
    },
    id: "path3779-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.683022,5.8438335 C 12.201041,5.8644994 11.723078,5.93993 11.257181,6.0659921 8.4536419,6.817043 6.4378964,9.2794393 6.2338575,12.201859 6.4378931,9.2794393 8.4536419,6.8171467 11.257181,6.0659921 11.723078,5.9409633 12.201036,5.866566 12.683022,5.8438335 Z",
    style: {
      clipRule: "evenodd",
      fill: "none",
      fillRule: "evenodd",
      stroke: "#3F3F3F",
      strokeWidth: 0.61421096,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      shapeRendering: "geometricPrecision"
    },
    id: "path3783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3857",
    d: "m 14.49526,13.323829 0.934236,0.934207 H 18.8993 c 0.243245,0 0.440397,0.196948 0.440397,0.440236 v 3.963679 c 0,0.243289 -0.197164,0.440237 -0.440397,0.440237 h -3.96364 c -0.243243,0 -0.440395,-0.196948 -0.440395,-0.440237 v -3.469818 l -0.934241,-0.934097 h -3.469806 c -0.2432449,0 -0.440403,-0.196948 -0.440403,-0.440237 V 9.8541218 c 0,-0.2432886 0.197164,-0.4402365 0.440403,-0.4402365 h 3.963635 c 0.243217,0 0.440403,0.1969479 0.440403,0.4402365 z m -3.523235,-2.589068 v 2.202067 h 2.202018 v -2.202067 z m 4.844444,4.844482 v 2.201958 h 2.202021 v -2.201958 z",
    style: {
      fill: "#3F3F3F",
      strokeWidth: 0.80740714
    },
    shapeRendering: "geometricPrecision"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeRemoteIcon);
export default __webpack_public_path__ + "static/media/node-remote-icon.51884cedcd58256b258fb16498ed7f49.svg";
export { ForwardRef as ReactComponent };